<div class="card-sessao">
  <!-- linha superior -->
  <div class="linha-superior">
    <app-card-sessao-linha-superior
      [nomeContato]="sessao?.contato?.nome"
      [numeroContato]="sessao?.contato?.numero"
      [isAtivo]="sessao?.ativo"
      [isExibicao]="isExibicao"
      [sessao]="sessao"
      (exibirDetalhes)="abrirModalDetalhes()"
      (modalChat)="abrirModalChat()"
      (editarDetalhes)="abrirModalEdicaoDetalhes()"
      (reiniciarSessao)="abrirModalReiniciarSessao()"
    ></app-card-sessao-linha-superior>
  </div>

  <!-- linha inferior -->
  <div class="linha-inferior">
    <div class="coluna">
      <span class="label">Etapa do Fluxo</span>
      <span class="valor">{{ sessao?.fluxo?.nome || '-' }} | {{ sessao?.etapa?.titulo || '—' }}</span>
    </div>
    <div class="coluna">
      <span class="label">Tempo na Etapa</span>
      <span class="valor">{{ sessao?.tempoEtapaAtual ?? '--' }}h</span>
    </div>
    <div class="coluna" style="flex: 1 1 7%;">
      <span class="label">Canal</span>
      <span class="valor">{{ sessao?.canal?.nome ?? '--' }}</span>
    </div>
    <div class="coluna">
      <span class="label">Data Abertura</span>
      <span class="valor">{{ (sessao!.dataInicio | date:'dd/MM/yyyy - HH:mm') ?? '--' }}</span>
    </div>
    <div class="coluna">
      <span class="label">Última Interação</span>
      <span class="valor">{{ (sessao!.dataUltimaMensagem | date:'dd/MM/yyyy - HH:mm') ?? '--' }}</span>
    </div>
    <div class="coluna" style="flex: 1 1 20%;">
      <span class="label">N. remetente</span>
      <span class="valor">{{ sessao?.conta?.nome }} | {{ sessao?.conta?.numero | celularMask }}</span>
    </div>
    <div class="coluna align-end">
      <span class="label">ID</span>
      <span class="valor">{{ sessao?.id ?? '--' }}</span>
    </div>
    <div class="coluna imagem">
      @if (sessao && sessao.operadorUuid && sessao.operadorExtensaoImg) {
        <img [src]="gerarUrl(sessao.operadorUuid, sessao.operadorExtensaoImg, 'usuario-img')" alt="Foto operador" />
      } @else {
        <img src="assets/icones/box-happy.png" alt="Sem imagem" />
      }
    </div>
  </div>
</div>

